import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/car/seizedcardetail',
  title: '查扣汽车管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
